import * as dateUtil from '../lib/dateUtil'

export default {
  methods: {
    tagType (row) {
      if (row.document === 2) {
        return 'info'
      }
      if (row.document === 3) {
        return ''
      }
      return row.type == 1 ? 'success' : 'danger'
    },
    tableRowClassName ({row, index}) {
      return row.type == 1 ? 'text-success' : 'text-danger'
    },
    dateFormatter (row, column) {
      const date = new Date(row[column.property])
      return dateUtil.format(date, 'DD.MM.YYYY')
    },
    invoiceNumFormatter (row, column) {
      return this.common.formatInvoiceNum(row[column.property])
    },
    contragentFormatter (row, column) {
      return row.Contragent.companyName ? row.Contragent.companyName : row.Contragent.name
    },
    subjectsFormatter (row, column) {
      if (row.description) {
        return row.description
      }

      var subjects = row[column.property]
      return subjects.map(s => { return this.common.invoiceSubjectText(s, row) }).join(' | ')
    },
    priceFormatter (row, column) {
      return this.common.formatPrice(row[column.property], false)
    },
    companyFormatter (row, column) {
      return row[column.property].name.split(' ').slice(0, 2).join(' ')
    },
    methodFormatter (row, column) {
      return this.consts.paymentMethod[row[column.property]].title.replace(' платеж', '')
    }
  }
}
